import { Stack, Text } from "@mantine/core"

import { CalendarAppointment as CalendarAppointmentType } from "../../../../@client/Theasoft_ApiServer_Calendar"
import { useTranslation } from "react-i18next"
import { v4 } from "uuid"
import { CalendarAppointment } from "./CalendarAppointment"

interface Props {
  appointments?: CalendarAppointmentType[]
}

export function AppointmentStack({ appointments }: Props) {
  const { t } = useTranslation("app_server")

  return (
    <Stack gap="sm" h="100%" w="100%">
      {appointments?.length ? (
        appointments.map((appointment) => (
          <CalendarAppointment appointment={appointment} key={v4()} />
        ))
      ) : (
        <Text>{t("NoAppointments")}</Text>
      )}
    </Stack>
  )
}
